var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.inProgress)?_c('p',[_vm._v("Activating")]):(_vm.hasError)?_c('p',[_vm._v(" Link is invalid or the account has been already activated ")]):_c('p',[_vm._v(" Account has been activated ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }